module.exports = __webpack_public_path__ + "static/media/stop_icon.6cb69751.svg";